import { ROI_ANALYTICS_TABLE } from '../../../../../../shared/constants/analytics/contexts';
import type { ReportActiveMode } from 'client/js/main/screens/ScreenRoiHub/types';
import type { ReportQuery } from 'client/js/main/types/analytics';

export class RoiAnalyticsService {
  public shouldAdjustQueryForTreeView(reportQuery: ReportQuery, activeMode: ReportActiveMode) {
    return activeMode === 'tree' && reportQuery.context === ROI_ANALYTICS_TABLE;
  }

  public adjustQueryForTreeView(reportQuery: ReportQuery) {
    const [topLevelDimension] = reportQuery.dimensions;
    reportQuery.dimensionsToExplain = reportQuery.dimensions;
    reportQuery.dimensions = [topLevelDimension];
    return reportQuery;
  }

  public static areDimensionsEqual(dimensionArray1: string[], dimensionArray2: string[]) {
    const arr1 = [...(dimensionArray1 || [])];
    const arr2 = [...(dimensionArray2 || [])];
    return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index]);
  }
}
